<template>
    <div style=" height: 100%;">
        <div id="tzgg-body" ref="tzggElement">
        <CCBlockFrame :header="header">
            <ul v-if="allDataList.length > 0" id="item-body" class="autoStyle">
                <template class="link-message">
                    <li v-for="(item, index) in allDataList" :key="index" class="link-message" @click="onCellLink(item, index)">
                        <div class="item">
                            <!-- <div v-if="item.readed=='0'" class="title" style="font-weight:700;"><span style="display:flex;"><span style="display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.flSubject }}</span> <span style="line-height: 30px;"><svg-icon style="color: #9B9B9B;font-size: 20px;" class-name="newT" icon-class="newT" /></span></span></div> -->
                            <div class="title" style="color: #333333">
                                <span class="msg">{{ item.flSubject||item.certName }}</span>

                            </div>
                            <div class="bottom">
                                <!-- <span style="text-align:left" class="name">{{ item.wfNodeNames }}</span> -->
                                <span style="text-align: right" class="name">{{ item.projectName||item.wtUnit }}</span>
                                <span class="time">{{ item.contractDate| dateTrans }}</span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <div v-else>
                <div slot="empty" style="text-align: center; margin-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
                </div>
            </div>

        </CCBlockFrame>

    </div>

</div>

</template>

<script>
const moment = require('moment')
const nowTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
import { mapGetters } from 'vuex'
export default {
    name: 'PatyBuildingActivities',
    components: {},
    filters: {
        dateTrans(date) {
            if (!date) return ''
            return window.moment(date).format('YYYY年MM月DD日')
        }
    },
    props: {
        title: { type: String, default: '公告' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            // 全部数据列表
            allDataList: [],
            // 数据列表
            dataList: [],
            header: {
                title: [
                    {
                        name: '招标业绩资料',
                        code: 'yjszbyezl',
                        click: this.tabClick
                    },
                    {
                        name: '造价业绩资料',
                        code: 'yjszjyjzl',
                        click: this.tabClick
                    },
                    {
                        name: '其它业绩资料',
                        code: 'yjsqtzl',
                        click: this.tabClick
                    }
                ],
                more: true,
                icon: this.appletData.icon,
                code: 'yjszbyezl'
            },
            tabName: '招标业绩资料',
            moduleInfo1: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/zzgl/certInfo/form_newLook.html',
                'winWidth': 1000,
                'delUrl': 'zzgl/certInfo/delete',
                'addNewUrl': 'zzgl/certInfo/addNew',
                'insertUrl': 'zzgl/certInfo/insert',
                'moduleCode': 'certInfo',
                'listAdvSearchExpandPanel': 0,
                'winHeight': 600,
                'updateUrl': 'zzgl/certInfo/update',
                'listDataUrl': 'zzgl/certInfo/listdata',
                'getByIdUrl': 'zzgl/certInfo/getById',
                'listAdvSearchAllFields': 0
            },
            moduleInfo2: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/zzgl/personalCertInfo/form.html',
                'winWidth': 1000,
                'delUrl': 'zzgl/personalCertInfo/delete',
                'addNewUrl': 'zzgl/personalCertInfo/addNew',
                'insertUrl': 'zzgl/personalCertInfo/insert',
                'moduleCode': 'personalCertInfo',
                'listAdvSearchExpandPanel': 0,
                'winHeight': 600,
                'updateUrl': 'zzgl/personalCertInfo/update',
                'listDataUrl': 'zzgl/personalCertInfo/listdata',
                'getByIdUrl': 'zzgl/personalCertInfo/getById',
                'listAdvSearchAllFields': 0
            },
            moduleInfo3: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/dagl/otxmArch/form.html',
                'winWidth': 1000,
                'delUrl': 'dagl/otxmArch/delete',
                'addNewUrl': 'dagl/otxmArch/addNew',
                'insertUrl': 'dagl/otxmArch/insert',
                'moduleCode': 'otxmArch',
                'listAdvSearchExpandPanel': 0,
                'winHeight': 600,
                'updateUrl': 'dagl/otxmArch/update',
                'listDataUrl': 'dagl/otxmArch/listdata',
                'getByIdUrl': 'dagl/otxmArch/getById',
                'listAdvSearchAllFields': 0
            }
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {},
    created() {
        this.getAllData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        tabClick(data) {
            this.tabName = data.name
            this.getTz(data.name)
        },
        async getTz(type) {
            console.log(type, 123)

            if (type === '招标业绩资料') {
                const listdataConfig = {
                // orderBy: 'pushTime desc',
                    pageNum: 1,
                    pageSize: 10000,
                    order: 'asc',
                    listpageViewUrl: 'zbgl.jggd.list_dYkvtJ.vue'
                // urlsearch: 'flFormName!:通知公告'
                }
                this.$app.listdata('zbgl/jggd/listdata', listdataConfig).then((res) => {
                    console.log(res, 1)
                    this.allDataList = res.body.pageInfo.list
                })
            } else if (type === '造价业绩资料') {
                const listdataConfig = {
                // orderBy: 'pushTime desc',
                    pageNum: 1,
                    pageSize: 10000,
                    order: 'asc',
                    listpageViewUrl: 'zbgl.zjxmJggd.list_x5e5sF.vue'
                // urlsearch: 'flFormName!:通知公告'
                }
                this.$app.listdata('zjgl/zjxmJggd/listdata', listdataConfig).then((res) => {
                    this.allDataList = res.body.pageInfo.list
                })
            } else {
                const listdataConfig = {
                // orderBy: 'pushTime desc',
                    pageNum: 1,
                    pageSize: 10000,
                    order: 'asc',
                    listpageViewUrl: 'dagl.otxmArch.list_jxUPu5.vue'
                // urlsearch: 'flFormName!:通知公告'
                }
                this.$app.listdata('dagl/otxmArch/listdata', listdataConfig).then((res) => {
                    this.allDataList = res.body.pageInfo.list
                })
            }
        },
        getAllData() {
            const listdataConfig = {
                // orderBy: 'pushTime desc',
                pageNum: 1,
                pageSize: 10000,
                order: 'asc',
                listpageViewUrl: 'zbgl.jggd.list_dYkvtJ.vue'
                // urlsearch: 'flFormName!:通知公告'
            }
            this.$app.listdata('zbgl/jggd/listdata', listdataConfig).then((res) => {
                this.allDataList = res.body.pageInfo.list
            })
        },
        onCellLink(row) {
            console.log(row, 2)
            if (this.tabName === '招标业绩资料') {
    		this.$http({
                    url: 'zbgl/zbxmArch/listdata',
                    method: 'post',
                    params:
                    {
                        urlsearch: 'projectCode:' + row.projectCode
                    },
                    contentType: 'application/x-www-form-urlencoded'
                }).then(res => {
                    const linkrow = res.body.pageInfo.list[0]
                    window.open('#/zbtzView?wfEngineUrl=zbgl/zbxmArch&busiDataId=' + linkrow.id + '&logoTitle=' + encodeURIComponent('招标管理/' + linkrow.flSubject))
                })
            } else if (this.tabName === '造价业绩资料') {
                this.$http({
                    url: 'zjgl/zjxmArch/listdata',
                    method: 'post',
                    params:
                    {
                        urlsearch: 'projectCode:' + row.projectCode
                    },
                    contentType: 'application/x-www-form-urlencoded'
                }).then(res => {
                    const linkrow = res.body.pageInfo.list[0]
                    window.open('#/zjtzView?wfEngineUrl=zjgl/zjxmArch&busiDataId=' + linkrow.id + '&logoTitle=' + encodeURIComponent('造价管理/' + linkrow.flSubject))
                })
            } else {
                window.open('#/newBusiForm?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo3)) + '&title=' + encodeURIComponent('待接收资料') + '&busiInfo=' + encodeURIComponent('其它资料') + '&formUrl=dagl.otxmArch.form&noEdit=true')
            }
        }
    }
}
</script>

  <style scoped lang="scss">
#tzgg-body {
    height: 100%;
    // @import url(); 引入公共css类
    #item-body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        .link-message + .link-message {
            border-top: 1px dashed #ebeef5;
            // border-top:none !important;
        }
        .link-message {
            width: 100%;
            height: 71px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            list-style: none;
            padding: 10px 20px;
            .item {
                // padding: 10px 0;
                width: 100%;
                height: 100%;
            }

            cursor: pointer;
            &:hover {
                // background-color: #F5F7FA;
            }
            &:last-child {
                border-bottom: none;
            }
            .title {
                font-size: 14px;
                color: #333333;
                height: 25px;
                line-height: 25px;
                width: 100%;
                position: relative;
                padding-right: 10px;
                display: inline-block;
                display: flex;
                .msg {
                    display: block;
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    width: 100%;
                }
                .no-read {
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: red;
                    position: absolute;
                    left: -10px;
                    top: 12px;
                    z-index: 100;
                }
            }
            .bottom {
                font-size: 13px;
                color: #9b9b9b;
                height: 25px;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                .name {
                    display: inline-block;

                    font-size: 13px;
                }
                .time {
                    display: block;
                    width: 106px;
                    float: right;
                    margin-right: 10px;
                    font-size: 13px;
                }
                .sender {
                    font-size: 12px;
                }
            }
        }
    }
    .time {
            display: block;
            display: inline-block;
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: #ec8423;
            text-align: right;
            width: 40%;
        }
    // .autoStyle{
    //     height: 100px !important;
    //     overflow-y: auto;
    // }
    // .autoStyle::-webkit-scrollbar{
    //     display: none;
    // }
}
</style>
